import { Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";

interface RowData {
  email: { selected: number; compared: number; change: number };
  targeting: { selected: number; compared: number; change: number };
  profiling: { selected: number; compared: number; change: number };
}

const ConsentTable = ({ profilingData }: { profilingData: RowData[] }) => {
  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell
            colSpan={3}
            align="center"
            sx={{
              fontWeight: "bold",
              width: "27.7%",
              borderRight: "1px solid #696969",
              textAlign: "center !important",
            }}
          >
            Email Consent
          </TableCell>
          <TableCell
            colSpan={3}
            align="center"
            sx={{
              fontWeight: "bold",
              width: "27.7%",
              borderRight: "1px solid #696969",
              textAlign: "center !important",
            }}
          >
            Targeting Consent
          </TableCell>
          <TableCell
            colSpan={3}
            align="center"
            sx={{
              fontWeight: "bold",
              width: "27.7%",
              textAlign: "center !important",
            }}
          >
            Profiling Consent
          </TableCell>
        </TableRow>

        <TableRow sx={{ bgcolor: "#f7f8fa" }}>
          <TableCell align="center" sx={{ fontWeight: "bold" }}>
            Selected Date
          </TableCell>
          <TableCell align="center" sx={{ fontWeight: "bold" }}>
            Compared Date
          </TableCell>
          <TableCell align="center" sx={{ fontWeight: "bold", borderRight: "1px solid #696969" }}>
            % Change
          </TableCell>

          {/* Targeting */}
          <TableCell align="center" sx={{ fontWeight: "bold" }}>
            Selected Date
          </TableCell>
          <TableCell align="center" sx={{ fontWeight: "bold" }}>
            Compared Date
          </TableCell>
          <TableCell align="center" sx={{ fontWeight: "bold", borderRight: "1px solid #696969" }}>
            % Change
          </TableCell>

          {/* Profiling */}
          <TableCell align="center" sx={{ fontWeight: "bold" }}>
            Selected Date
          </TableCell>
          <TableCell align="center" sx={{ fontWeight: "bold" }}>
            Compared Date
          </TableCell>
          <TableCell align="center" sx={{ fontWeight: "bold" }}>
            % Change
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {profilingData.map((row) => (
          <TableRow key={Math.random()}>
            {/* Email */}
            <TableCell align="center">
              {row.email.selected.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </TableCell>
            <TableCell align="center">
              {row.email.compared.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </TableCell>
            <TableCell align="center" sx={{ borderRight: "1px solid #696969" }}>
              {row.email.change.toFixed(2)}%
            </TableCell>

            {/* Targeting */}
            <TableCell align="center">
              {row.targeting.selected.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </TableCell>
            <TableCell align="center">
              {row.targeting.compared.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </TableCell>
            <TableCell align="center" sx={{ borderRight: "1px solid #696969" }}>
              {row.targeting.change.toFixed(2)}%
            </TableCell>

            {/* Profiling */}
            <TableCell align="center">
              {row.profiling.selected.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </TableCell>
            <TableCell align="center">
              {row.profiling.compared.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </TableCell>
            <TableCell align="center">{row.profiling.change.toFixed(2)}%</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default ConsentTable;
